(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.ch-header').forEach(header=>{
  const drawerDetails=header.querySelector('.ch-mobile-menu .menu-drawer-container');
  const syncMobileDrawer=()=>{
    /* Keep the drawer below the announcement section without modifying it. */
    const headerSection=document.getElementById('shopify-section-{{ section.id }}');
    let announcementBottom=0;
    if(headerSection){
      let sibling=headerSection.previousElementSibling;
      while(sibling){
        const rect=sibling.getBoundingClientRect();
        if(rect.height>0 && rect.bottom>announcementBottom) announcementBottom=rect.bottom;
        sibling=sibling.previousElementSibling;
      }
    }
    document.documentElement.style.setProperty('--clearance-announcement-bottom',Math.max(0,Math.round(announcementBottom))+'px');

    if(!drawerDetails)return;
    /* Always calculate from the SAME element whether the drawer is open or closed.
       Search/logo visibility must never change the drawer top during its animation. */
    const mobileRow=header.querySelector('.ch-mobile-row');
    const rowRect=mobileRow ? mobileRow.getBoundingClientRect() : header.getBoundingClientRect();
    const drawerTop=Math.max(0,Math.round(rowRect.bottom));
    document.documentElement.style.setProperty('--clearance-mobile-header-bottom',drawerTop+'px');
    header.style.setProperty('--clearance-mobile-header-bottom',drawerTop+'px');

    const isOpen=drawerDetails.open&&window.innerWidth<=989;
    const mobileSearch=header.querySelector(':scope > .ch-mobile-search');
    if(mobileSearch){
      if(isOpen) mobileSearch.style.setProperty('display','none','important');
      else mobileSearch.style.removeProperty('display');
      mobileSearch.setAttribute('aria-hidden',isOpen?'true':'false');
    }
    /* Explicit global state avoids cross-section z-index conflicts with the announcement bar. */
    header.classList.toggle('drawer-is-open',isOpen);
    document.documentElement.classList.toggle('clearance-drawer-open',isOpen);
    document.body.classList.toggle('clearance-drawer-open',isOpen);
  };
  if(drawerDetails){
    /* Do not change global drawer state on pointerdown.
       Waiting for the native <details> toggle keeps the announcement/header
       and drawer in the same painted frame and removes the final micro-jerk. */
    /* Dawn toggles <details> synchronously, which skips the first transition frame.
       Drive the drawer class one animation-frame later so the browser paints the
       closed state first, then performs a real slide transition. */
    drawerDetails.classList.remove('drawer-animating','drawer-visible');
    drawerDetails.addEventListener('toggle',()=>{
      drawerDetails.classList.remove('drawer-animating','drawer-visible');
      syncMobileDrawer();
      const mobileSearch=header.querySelector(':scope > .ch-mobile-search');
      if(mobileSearch){
        mobileSearch.style.setProperty('display', drawerDetails.open ? 'none' : '', drawerDetails.open ? 'important' : '');
        mobileSearch.setAttribute('aria-hidden', drawerDetails.open ? 'true' : 'false');
      }
    });
    window.addEventListener('resize',syncMobileDrawer,{passive:true});
    syncMobileDrawer();
  }
  header.querySelectorAll('.ch-nav-item').forEach(item=>{const mega=item.querySelector(':scope > .ch-mega');if(!mega)return;const trigger=item.querySelector(':scope > .ch-nav-link');trigger.setAttribute('aria-haspopup','true');trigger.setAttribute('aria-expanded','false');item.addEventListener('mouseenter',()=>trigger.setAttribute('aria-expanded','true'));item.addEventListener('mouseleave',()=>trigger.setAttribute('aria-expanded','false'));item.addEventListener('focusin',()=>trigger.setAttribute('aria-expanded','true'));item.addEventListener('focusout',e=>{if(!item.contains(e.relatedTarget))trigger.setAttribute('aria-expanded','false')})})})});
document.addEventListener('shopify:block:select',e=>{const block=e.target.closest('.ch-mega');if(block)block.classList.add('is-editor-open')});
document.addEventListener('shopify:block:deselect',e=>{const block=e.target.closest('.ch-mega');if(block)block.classList.remove('is-editor-open')});
class StickyHeader extends HTMLElement{connectedCallback(){this.header=document.querySelector('.section-header');this.always=['always','reduce-logo-size'].includes(this.dataset.stickyType);this.last=0;if(this.always)this.header.classList.add('shopify-section-header-sticky');this.handler=()=>{if(this.always)return;const y=window.scrollY;if(y>this.last&&y>this.header.offsetHeight)this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');else if(y<this.last)this.header.classList.remove('shopify-section-header-hidden');if(y<=0)this.header.classList.remove('shopify-section-header-sticky');this.last=y};window.addEventListener('scroll',this.handler,{passive:true});document.documentElement.style.setProperty('--header-height',this.header.offsetHeight+'px')}disconnectedCallback(){window.removeEventListener('scroll',this.handler)}}if(!customElements.get('sticky-header'))customElements.define('sticky-header',StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
